import { render } from "./DatosAlumnoCard.vue?vue&type=template&id=80f852a2&scoped=true"
import script from "./DatosAlumnoCard.vue?vue&type=script&lang=js"
export * from "./DatosAlumnoCard.vue?vue&type=script&lang=js"

import "./DatosAlumnoCard.vue?vue&type=style&index=0&id=80f852a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f852a2"]])

export default __exports__